"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clientToBarEncoder = exports.barToClientEncoder = void 0;
const _1 = require(".");
const utils_1 = require("../utils");
class BarToClientEncoder {
    encode(value) {
        let messages = [];
        if (Array.isArray(value)) {
            messages = value;
        }
        else {
            messages = [value];
        }
        const wrapped = {
            version: 1,
            type: "bar-to-client",
            messages,
        };
        return JSON.stringify(wrapped);
    }
    decode(value) {
        try {
            const decodedJson = JSON.parse(value);
            const decoded = _1.WrappedBarToClientSchema.parse(decodedJson);
            return decoded.messages
                .map((message) => {
                const parsed = _1.BarToClientSchema.safeParse(message);
                if (parsed.success) {
                    return parsed.data;
                }
                return null;
            })
                .filter(utils_1.notNull);
        }
        catch (e) {
            return [];
        }
    }
}
exports.barToClientEncoder = new BarToClientEncoder();
class ClientToBarEncoder {
    encode(value) {
        let messages = [];
        if (Array.isArray(value)) {
            messages = value;
        }
        else {
            messages = [value];
        }
        const wrapped = {
            version: 1,
            type: "bar-to-client",
            messages,
        };
        return JSON.stringify(wrapped);
    }
    decode(value) {
        try {
            const decodedJson = JSON.parse(value);
            const decoded = _1.WrappedBarToClientSchema.parse(decodedJson);
            return decoded.messages
                .map((message) => {
                const parsed = _1.ClientToBarSchema.safeParse(message);
                if (parsed.success) {
                    return parsed.data;
                }
                return null;
            })
                .filter(utils_1.notNull);
        }
        catch (e) {
            return [];
        }
    }
}
exports.clientToBarEncoder = new ClientToBarEncoder();
